/** Maximum years allowed for Create Position experience (single value or range). */

export const EXPERIENCE_MAX_YEARS = 75;



const SINGLE_YEARS = /^(\d+)(\s+years?)?$/i;

const PLUS_YEARS = /^(\d+)\+(\s+years?)?$/i;

const RANGE_YEARS = /^(\d+)\s*-\s*(\d+)(\s+years?)?$/i;



/**

 * Sanitize experience input: digits, optional +, range hyphen, and "years" text.

 * Leading "-" is stripped — negative values are not allowed.

 */

export function sanitizeExperienceInput(raw) {

  let s = String(raw ?? '').replace(/[^0-9+\-a-zA-Z\s]/g, '');

  s = s.replace(/^-+/, '');

  s = s.replace(/\s+/g, ' ');

  if (s.length > 40) s = s.slice(0, 40);

  const hyphenIdx = s.indexOf('-');

  if (hyphenIdx === -1) {

    return s;

  }

  const before = s.slice(0, hyphenIdx).replace(/-/g, '');

  const after = s.slice(hyphenIdx + 1).replace(/-/g, '');

  if (!before.length) {

    return after;

  }

  return `${before}-${after}`;

}



function primaryYearsFromMatch(match) {

  return Number(match[1]);

}



/**

 * Validate experience for Create Position structured form.

 * Accepts: 5, 6+, 2+ years, 1-3, 4-7 years (each bound 0–75; ranges min ≤ max).

 * @returns {string|undefined} error message or undefined when valid

 */

export function validateExperienceField(value) {

  const raw = String(value ?? '').trim();

  if (!raw) return 'Experience is required.';

  if (raw.startsWith('-') || /^-\d/.test(raw)) {

    return 'Experience cannot be negative.';

  }



  let match = raw.match(SINGLE_YEARS);

  if (match) {

    const n = primaryYearsFromMatch(match);

    if (n > EXPERIENCE_MAX_YEARS) {

      return `Experience cannot exceed ${EXPERIENCE_MAX_YEARS} years.`;

    }

    return undefined;

  }



  match = raw.match(PLUS_YEARS);

  if (match) {

    const n = primaryYearsFromMatch(match);

    if (n > EXPERIENCE_MAX_YEARS) {

      return `Experience cannot exceed ${EXPERIENCE_MAX_YEARS} years.`;

    }

    return undefined;

  }



  match = raw.match(RANGE_YEARS);

  if (match) {

    const min = Number(match[1]);

    const max = Number(match[2]);

    if (min > max) {

      return 'Experience range minimum cannot be greater than maximum.';

    }

    if (min > EXPERIENCE_MAX_YEARS || max > EXPERIENCE_MAX_YEARS) {

      return `Each value in the experience range must be between 0 and ${EXPERIENCE_MAX_YEARS} years.`;

    }

    return undefined;

  }



  return `Enter experience as a number (e.g. 5, 6+), with years (e.g. 2+ years), or a range (e.g. 1-3).`;

}



export function isValidExperienceField(value) {

  return validateExperienceField(value) === undefined;

}


